import Layouts from './layouts';

export default Layouts;
